// extracted by mini-css-extract-plugin
module.exports = {"input":"CustomCheckbox_input__NMaLA","checkboxText":"CustomCheckbox_checkboxText__4HH6J","required":"CustomCheckbox_required__vewbU","small":"CustomCheckbox_small__UlyK0"};